import { render } from "./CodeControllerForm.vue?vue&type=template&id=c6c60b76&ts=true"
import script from "./CodeControllerForm.vue?vue&type=script&lang=ts"
export * from "./CodeControllerForm.vue?vue&type=script&lang=ts"

import "./CodeControllerForm.vue?vue&type=style&index=0&id=c6c60b76&lang=sass"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__